// extracted by mini-css-extract-plugin
export default {"home":"home_home__1jket","main":"home_main__rMAgL"};